<div class="content">
  <h4>Oh oh... You're not authorized to go there 😬</h4>
  <p>Click <a href="/">me</a> to get home</p>
</div>
